// import { makeVisibleData } from '../plugins/filters/filters.selectors'
import Settings from 'settings'

export const categories = {
  name: 'categories',
  request: {
    url: `${Settings.api}/categories`,
    middleware: {
      checkStore: (store) => store.categories.data.length, // check if data is already in the store
    }
  },
  state: {
    data: [], // items needs an empty array, so we override default 'data' here
  },
}

// export const getVisibleData = makeVisibleData(categories.filters)



// WEBPACK FOOTER //
// ./src/redux/models/categories.js